import { useState, useEffect } from "react";
import axios from 'axios';

//constants
import { urlJson } from '../Constants';

const UseData = () => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const responseStatusOk = 200;

    useEffect(() => {
        const getData = async () => {
            const response = await axios(urlJson);
            
            if(response.status === responseStatusOk){
                setData(Object.values(response.data));
                setLoading(false);
            }            
        }           

        getData();                        
    },[]);

    return [loading, data];
};

export { UseData };